module.exports = __webpack_public_path__ + "static/img/aboutus.dfbad5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus.png
// module id = 6uiW
// module chunks = 21